import clsx from 'clsx'
import { forwardRef } from 'react'

import mainStyles from 'assets/css/main.module.scss'

import styles from './CardGridLayout.module.scss'

interface Card {
  title: string
  description: string
  leftBorderColor?: string
  cardClassName?: string
}

interface Props {
  title: string
  titleDecoration?: 'underline' | 'stars'
  decorationColor?: 'red' | 'copper' | 'blue' | 'amber' | 'darkYellow'
  cards?: Card[]
  className?: string
  color?: string
}

const GridCardLayout = forwardRef<HTMLDivElement, Props>(
  ({ title, titleDecoration, cards, className, decorationColor = 'red' }, ref) => {
    const stars = {
      red: styles.red,
      copper: styles.copper,
      blue: styles.blue,
      amber: styles.amber,
      darkYellow: styles.darkYellow,
    }

    return (
      <div ref={ref} className={clsx(styles.GridCardLayout, mainStyles.container, className)}>
        <div className={styles.titleContainer}>
          <div
            className={clsx(
              styles.title,
              titleDecoration === 'underline' && styles.underline,
              titleDecoration === 'stars' && styles.stars,
              titleDecoration === 'stars' && stars[decorationColor],
            )}
          >
            {title}
          </div>
        </div>
        <div className={styles.gridContainer}>
          {!!cards?.length &&
            cards.map(({ description, title, leftBorderColor = '#000000', cardClassName }, index) => (
              <div
                key={index}
                className={clsx(styles.card, cardClassName)}
                style={{ borderLeft: `16px solid ${leftBorderColor}` }}
              >
                <div className={styles.cardTitle}>{title}</div>
                <div className={styles.cardDescription}>{description}</div>
              </div>
            ))}
        </div>
      </div>
    )
  },
)

export default GridCardLayout
